// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"ff41a498","581":"b136a207","829":"e51869af","913":"5f5fe264"}[chunkId] + ".chunk.js";
};